import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { getCardImage } from "@shared/blocks/helpers";
import "./view.scss";
const IPHONE_RATIOS = [4 / 3, 16 / 9, 1];
const RATIO_TOLERANCE = 0.03;
function isIPhoneCameraRatio(width, height) {
    const ratio = Math.max(width, height) / Math.min(width, height);
    return IPHONE_RATIOS.some((r) => Math.abs(ratio - r) <= RATIO_TOLERANCE);
}
export const ImageBlockView = memo(({ block }) => {
    const imageUrl = getCardImage(block);
    if (!imageUrl) {
        return _jsx("span", { className: "light-text", children: block.title ?? "Image" });
    }
    const { width, height } = block.content;
    const shouldContain = width && height && isIPhoneCameraRatio(width, height) === false;
    const fitClass = shouldContain ? "image-container--fit-contain" : "";
    return (_jsx("div", { className: `image-container ${fitClass}`, children: _jsx("img", { src: imageUrl, alt: block.title ?? "" }) }));
});
